import { CircularProgress } from "@mui/material";
import { Background } from "./styles";

export default function DataTableLoadingComponent() {
  return (
    <Background>
      <CircularProgress size={32} value={100} />
    </Background>
  );
}
